const Cake = require("./cake.jpg");
const Candle = require("./candle.jpg");
const Carol = require("./carol.jpg");
const Cookie = require("./cookie.jpg");
const FirePlace = require("./fireplace.jpg");
const Present = require("./present.jpg");
const Reindeer = require("./reindeer.jpg");
const Santa = require("./santa.jpg");
const Scarf = require("./scarf.jpg");
const Snow = require("./snow.jpg");
const Snowman = require("./snowman.jpg");
const Sock = require("./sock.jpg");
const Stick = require("./stick.jpg");
const Tree = require("./tree.jpg");
const Wine = require("./wine.jpg");
const Wreath = require("./wreath.jpg");

export const Main = require("./main.jpeg");
export const Background = require("./background.jpeg");

export const images = {
  Cake,
  Candle,
  Carol,
  Cookie,
  FirePlace,
  Present,
  Reindeer,
  Santa,
  Scarf,
  Snow,
  Snowman,
  Sock,
  Stick,
  Tree,
  Wine,
  Wreath,
};
